import React from 'react'
import styled from 'styled-components'

const PersonIconI = styled.i`
  width: 0.75rem;
  height: 0.75rem;
  font-size: 0.75rem;
`

export const PersonIcon = () => {
  return (
    <div className='d-flex p-1 zocks-border-0.25 zocks-text-white zocks-bg-color-gray-900'>
      <PersonIconI className='d-flex bi bi-person-fill' />
    </div>
  )
}
